import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';

export const jsmSLASaveExperience = new UFOExperience('jsm-sla-save', {
	performanceType: ExperiencePerformanceTypes.InlineResult,
	type: ExperienceTypes.Experience,
});

export const jsmSLADeleteExperience = new UFOExperience('jsm-sla-delete', {
	performanceType: ExperiencePerformanceTypes.InlineResult,
	type: ExperienceTypes.Experience,
});
